<dx-select-box class="mat-field"
    [dataSource]="items | async"
    [displayExpr]="bindLabel"
    [valueExpr]="bindValue"
    [dropDownOptions]="dropDownOptions"
    [value]="selectedValue"
    [searchEnabled]="true"
    [showClearButton]="clearable"
    [disabled]="disabled"
    (onValueChanged)="selectedValue = $event.value">
</dx-select-box>
<input matInput hidden>
